import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apis from '../../services';

const investNow = createAsyncThunk('Investment API', async ({ id }) => {
  const responce = await apis.investNow({ id });
  return await responce;
});


const invest= createAsyncThunk('Investment', async (formData) => {
  const response = await apis.invest(formData);
  return response.data;
});


const investSlice = createSlice({
  name: 'investNow',
  initialState: {
    loading: false,
    investNow: null,
    error: null,
  },
  extraReducers: {
    [investNow.pending]: (state, action) => {
      state.loading = true;
    },
    [investNow.fulfilled]: (state, action) => {
      state.loading = false;
      state.investNow = action.payload;
    },
    [investNow.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export { investNow , invest };
export default investSlice.reducer;
